export default __webpack_public_path__ + "static/media/liberdade.2dda64e5.svg";